<template>
	<v-ons-page>
		<ons-toolbar>
			<div class="left"><ons-back-button></ons-back-button></div>
			<div class="center">Back</div>
		</ons-toolbar>
		<v-ons-list-title>Change your password</v-ons-list-title>
		<v-ons-list class="qf-input-list">
			<v-ons-list-item style="padding-top: 10px">
				<v-ons-input
						placeholder="Current password" float
						v-model="resetData.oldPassword"
						type="password"
						class="qf-login-input w100"
						modifier="material"
				></v-ons-input>
			</v-ons-list-item>
			<v-ons-list-item>
				<v-ons-input
						placeholder="New password (min. 6 characters)" float
						v-model="resetData.password"
						type="password"
						class="qf-login-input w100"
						modifier="material"
				></v-ons-input>
			</v-ons-list-item>
			<v-ons-list-item>
				<v-ons-input
						placeholder="Repeat new password" float
						v-model="resetData.newPassword"
						type="password"
						class="qf-login-input w100"
						modifier="material"
				></v-ons-input>
			</v-ons-list-item>
		</v-ons-list>
		<section class="qf-reset-controls qf-all-space">
			<v-ons-button class="button-margin" @click="submitChange" modifier="large" :disabled="disabledBtn">Save changes</v-ons-button>
		</section>
		<v-ons-alert-dialog modifier="rowfooter" :title="dialogueTitle" :visible.sync="dialogVisible" :footer="{
			Ok: () => dialogVisible = false
		}">
			{{dialogueMsg}}
		</v-ons-alert-dialog>
	</v-ons-page>
</template>

<script>
	import ApiFormData from '@/services/apiFormData';
	export default {
		name: "ChangePassword",
		data(){
			return {
				disabledBtn: true,
				dialogueMsg: '',
				dialogueTitle: '',
				dialogVisible:false,
				resetData: {
					oldPassword: '',
					password: '',
					newPassword: ''
				}

			}
		},
		methods: {
			submitChange() {
				let self = this;
				let requestData = new FormData;
				requestData.append('id',self.id);
				requestData.append('email',self.email);
				requestData.append('oldPassword',self.resetData.oldPassword);
				requestData.append('password',self.resetData.password);
				requestData.append('newPassword',self.resetData.newPassword);

				ApiFormData().post('user/password', requestData).then(response => {
					console.log("PW Change response: ", response.data);
					self.showPopTip('Password changed successfully!', '');
					self.resetData = {
						oldPassword: '',
						password: '',
						newPassword: ''
					};
				}).catch((err) => {
					self.showPopTip('Invalid current password', 'Error');
					console.log(err);
					//reject(err);
				});
			},
			showPopTip(message, title) {
				this.dialogueMsg = message;
				this.dialogueTitle = title;
				this.dialogVisible = true;
			}
		},
		watch: {
			resetData: {
				handler(obj) {
					console.log(obj.newPassword === obj.password);
					if(obj.newPassword === obj.password && obj.oldPassword.length > 3 && obj.newPassword.length > 5){
						this.disabledBtn = false;
					}else{
						this.disabledBtn = true;
					}
				},
				deep: true
			}
		}
	}
</script>

<style scoped>

</style>